import { render, staticRenderFns } from "./HomeWhatWeDo.vue?vue&type=template&id=13aa96e0&"
import script from "./HomeWhatWeDo.vue?vue&type=script&lang=js&"
export * from "./HomeWhatWeDo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports